import { useRef } from "react";
import { Maximize2, Minimize2 } from "lucide-react";
import { useFullscreen } from "../hooks/useFullscreen";

// Wraps a viewer container and adds a fullscreen toggle. On enter/exit the container becomes/leaves a
// full-viewport box, and R3F's <Canvas> auto-resizes to it (ResizeObserver).
export const FullscreenViewer = ({
  testId,
  baseClassName,
  overlayClassName = "duck-canvas-wrap fixed inset-0 z-[60] overflow-hidden bg-background",
  showButton = true,
  children,
}) => {
  const ref = useRef(null);
  const { active, overlay, toggle } = useFullscreen(ref);
  return (
    <div ref={ref} data-testid={testId} className={overlay ? overlayClassName : baseClassName}>
      {children}
      {showButton && (
        <button
          type="button"
          data-testid="fullscreen-btn"
          onClick={toggle}
          aria-label={active ? "Exit fullscreen" : "Enter fullscreen"}
          title={active ? "Exit fullscreen" : "Fullscreen"}
          className="absolute top-4 right-4 z-10 flex items-center justify-center h-10 w-10 rounded-full bg-background/80 backdrop-blur border border-border hover:bg-background transition-colors"
        >
          {active ? <Minimize2 className="h-4 w-4" /> : <Maximize2 className="h-4 w-4" />}
        </button>
      )}
    </div>
  );
};
